import { render, staticRenderFns } from "./MatchGoodsMngQpage.vue?vue&type=template&id=22caabff&scoped=true&"
import script from "./MatchGoodsMngQpage.vue?vue&type=script&lang=js&"
export * from "./MatchGoodsMngQpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22caabff",
  null
  
)

export default component.exports